import { Link } from 'react-router';
import { observer } from 'mobx-react-lite';
import osaka from '@/assets/hirakuza_osaka.png';
import tokyo from '@/assets/hirakuza_tokyo.png';
import { useStore } from '@/stores';
import User from './User';
import styles from './header.module.css';

const Header: React.FC = observer(() => {
  const { auth } = useStore();
  const logoUrl = auth.isTokyo ? tokyo : osaka;

  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        <Link to="/" className={styles.logo}>
          <img src={logoUrl} alt="logo" width="90" />
        </Link>
        <div className={styles.info}>
          <User />
        </div>
      </div>
    </header>
  );
});

export default Header;
